import PrintLayout from './PrintLayout';

export default PrintLayout;
